import {Component, Injector, Input} from '@angular/core';
import {BasePageComponent} from "../../../base/components/base-page.component";
import {ArticleFamilyConstants} from "../../constants/articles-family.constants";
import {ProductModel} from "../../../orders/models/product.model";
import {IdentificationTypeConstants} from "../../constants/identificationType.constants";
import {ProductConverter} from "../../../orders/converters/product.converter";
import {OrderModel} from "../../../orders/models/order.model";
import {OrderConverter} from "../../../orders/converters/order.converter";
import {SubjectRole} from "../../DTO/subjectRole";
import {ContactType} from "../../DTO/contactType";

@Component({
  selector: 'app-info-box',
  templateUrl: './info-box.component.html',
  styleUrls: ['./info-box.component.scss']
})
export class InfoBoxComponent extends BasePageComponent {
  IdentificationTypeConstants = IdentificationTypeConstants;
  minimizedReview: boolean;
  ArticleFamilyConstants = ArticleFamilyConstants;
  SubjectRole = SubjectRole;
  ContactType = ContactType;
  @Input() data: any;
  @Input() product: ProductModel;
  @Input() order: OrderModel;
  @Input() offersSelected?: any;

  constructor(injector: Injector, private productConverter: ProductConverter, private orderConverter: OrderConverter) {
    super(injector);

  }

  ngOnDestroyForChildren(): void {
    if (this.storageService.getPreference('reviewData')) {
      this.storageService.deletePreference('reviewData');
    }
    if (this.storageService.getPreference('reviewProductModel')) {
      this.storageService.deletePreference('reviewProductModel');
    }
    if (this.storageService.getPreference('reviewOrderModel')) {
      this.storageService.deletePreference('reviewOrderModel');
    }
  }

  ngOnInitForChildren(): void {
    if (this.storageService.getPreference('reviewData')) {
      this.data = this.storageService.getPreference('reviewData');
    }
    if (this.storageService.getPreference('reviewProductModel')) {
      this.product = this.productConverter.convertToModel(this.storageService.getPreference('reviewProductModel'));
    }
    if (this.storageService.getPreference('reviewOrderModel')) {
      this.order = this.orderConverter.convertToModel(this.storageService.getPreference('reviewOrderModel'));
    }

    this.minimizedReview = this.settingService?.setting?.layout?.minimizedReview;
    setTimeout(() => {
      this.notifyActionSimple('collapse', this.minimizedReview);
    }, 0);
  }

  pageName(): string {
    return "InfoBoxComponent";
  }

  collapseToggle() {
    this.minimizedReview = !this.minimizedReview;
    this.notifyActionSimple('collapse', this.minimizedReview);
  }
}
